/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}fab`;
const observedAttributes = {
    THEME: 'theme',
    DENSITY: 'density',
    ELEVATION: 'elevation'
};
const attributes = {
    ...observedAttributes
};
const selectors = {
    LABEL_SLOT: 'slot[name=label]'
};
const classes = {
    EXTENDED: `${elementName}--extended`
};
const defaults = {
    DEFAULT_THEME: 'secondary',
    DEFAULT_DENSITY: 'medium',
    DEFAULT_ELEVATION: 'raised'
};
export const FLOATING_ACTION_BUTTON_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    selectors,
    classes,
    defaults
};
